<app-header></app-header>
<ion-content>
  <div
    class="invoices-content gray-content-bg"
    #mainDivScroll
    cdkVirtualScrollingElement
    *ngIf="vm$ | async; let vm"
  >
    <div class="main-header">
      <app-header-filters
        [isTouch]="(isTouch$ | async)"
        [breadcrumbs]="vm.breadcrumbs"
        [service]="adjustPaymentService"
        [filters]="invoiceFilters"
        [showQuickDateFilterOption]="true"
        [showResetFilterOption]="true"
        [isLoading]="isInitialLoading(vm)"
        [platformType]="platformService?.platformType"
        [filterVm$]="vm$"
        [title]="'i18n.payments.adjustPayment.title'| translate"
        [isWindows]="platformService?.isWindows()"
        [quickFilters]="quickFilters"
        [defaultFilterId]="InvoiceFilterIds.TransactionNumber"
        [defaultDateFilterId]="InvoiceFilterIds.IssueDate"
        [showOrderNumberFilter]="showOrderNumber"
        (resetFiltersEmitter)="resetFilters()"
        (toggleStatusEmitter)="toggleStatusFilter($event, vm)"
        (filtersWillChangeEmitter)="filtersWillChange()"
      ></app-header-filters>
    </div>

    <div>
      <ion-grid
        *ngIf="vm.initialSelectedTransactions?.length > 0 && !vm.isLoadingTransaction && !isReloadingFromSortAction(vm); else loadingContent"
      >
        <ion-row class="selected-items-info">
          <ion-col class="selected-items-title" size="12" size-lg="6">
            <h5 data-cy="selected-items">
              {{ 'i18n.payments.adjustPayment.selectedItems' | translate: {
              itemCount: vm.selectedTransactions.length } }}
            </h5>
          </ion-col>
          <ion-col class="selected-items-label ion-hide-lg-up">
            <h5>
              {{ 'i18n.payments.adjustPayment.totalAmountWithColon' | translate
              }}
            </h5>
          </ion-col>
          <ion-col class="selected-items-amount">
            <h5>
              <span class="ion-hide-lg-down"
                >{{ 'i18n.payments.adjustPayment.totalAmount' | translate }}
              </span>
              {{ 'i18n.payments.adjustPayment.totalAmountPrepend' | translate
              }}<span data-cy="total-amount"
                >{{ vm.totalAmount | number :'1.2-2' }}</span
              >
            </h5>
          </ion-col>
        </ion-row>

        <ng-container
          [ngTemplateOutlet]="tableHeader"
          [ngTemplateOutletContext]="{ currentSortField: selectedSortField,
            currentSortDirection: selectedSortDirection,
            isSelectedItems: true,
            vm: vm}"
        ></ng-container>

        <ng-container
          *ngIf="platformService?.platformType === PlatformEnum.desktop; else touch"
        >
          <app-transaction-row-desktop
            *ngFor="let transaction of vm.initialSelectedTransactions;
              trackBy: trackByIdx
            "
            [vm]="transaction"
            [browserDimensions]="browserDimensions"
            [isTouch]="false"
            [selectable]="vm.isSelectable"
            [translatorText]="transactionRowText"
            [isPayable]="false"
            [shouldShowButtons]="false"
            [shouldHaveEditableAmount]="true"
            [showFullPO]="showFullPO"
            [showOrderNumber]="vm.showOrderNumber"
            [columnSizes]="columnSizes"
            (poClickEmitter)="poNumberClicked()"
            (paymentAmountChangeEmitter)="updatePaymentAmount(vm, $event)"
            (transactionRowClickEmitter)="selectTransactionRow($event, vm)"
            (viewInvoiceClickEmitter)="viewInvoice($event)"
          ></app-transaction-row-desktop>
        </ng-container>
        <ng-template #touch>
          <app-transaction-row-touch
            *ngFor="let transaction of vm.initialSelectedTransactions"
            [vm]="transaction"
            [isMobile]="isMobile"
            [selectable]="vm.isSelectable"
            [translatorText]="transactionRowText"
            [showOrderNumber]="vm.showOrderNumber"
            [shouldHaveEditableAmount]="true"
            (editAmountClickEmitter)="handleEditAmount($event, vm)"
            (transactionRowClickEmitter)="selectTransactionRow($event, vm)"
            (viewInvoiceClickEmitter)="viewInvoice($event)"
          ></app-transaction-row-touch>
        </ng-template>
      </ion-grid>
    </div>

    <div class="margin-bottom">
      <ng-container>
        <ion-grid
          *ngIf="!isInitialLoading(vm) && !isReloadingFromSortAction(vm); else loadingContent"
        >
          <ion-row class="other-items-info">
            <ion-col class="other-items-title">
              <h5 data-cy="other-items">
                {{ 'i18n.payments.adjustPayment.otherItems' | translate }}
              </h5>
            </ion-col>
          </ion-row>
          <ng-container
            [ngTemplateOutlet]="tableHeader"
            [ngTemplateOutletContext]="{ 
              currentSortField: sortField,
              currentSortDirection: sortDirection,
              vm: vm, 
              isSelectedItems: false
            }"
          ></ng-container>

          <cdk-virtual-scroll-viewport
            *ngIf="platformService?.platformType === PlatformEnum.desktop; else touch"
            itemSize="76"
            (scrolledIndexChange)="scrolledIndexChange($event, vm)"
          >
            <app-transaction-row-desktop
              *cdkVirtualFor="
                let transaction of vm.transactions;
                trackBy: trackByIdx
              "
              [vm]="transaction"
              [browserDimensions]="browserDimensions"
              [isTouch]="false"
              [selectable]="vm.isSelectable"
              [translatorText]="transactionRowText"
              [isPayable]="false"
              [shouldShowButtons]="false"
              [shouldHaveEditableAmount]="true"
              [showFullPO]="showFullPO"
              [showOrderNumber]="vm.showOrderNumber"
              [columnSizes]="columnSizes"
              (poClickEmitter)="poNumberClicked()"
              (paymentAmountChangeEmitter)="updatePaymentAmount(vm, $event)"
              (transactionRowClickEmitter)="selectTransactionRow($event, vm)"
              (viewInvoiceClickEmitter)="viewInvoice($event)"
            ></app-transaction-row-desktop>
          </cdk-virtual-scroll-viewport>

          <ng-template #touch>
            <cdk-virtual-scroll-viewport
              itemSize="156"
              (scrolledIndexChange)="scrolledIndexChange($event, vm)"
            >
              <app-transaction-row-touch
                *cdkVirtualFor="
                let transaction of vm.transactions;
                trackBy: trackByIdx
              "
                [vm]="transaction"
                [isMobile]="isMobile"
                [selectable]="vm.isSelectable"
                [translatorText]="transactionRowText"
                [showOrderNumber]="vm.showOrderNumber"
                [shouldHaveEditableAmount]="true"
                (editAmountClickEmitter)="handleEditAmount($event, vm)"
                (transactionRowClickEmitter)="selectTransactionRow($event, vm)"
                (viewInvoiceClickEmitter)="viewInvoice($event)"
              ></app-transaction-row-touch>
            </cdk-virtual-scroll-viewport>
          </ng-template>
          <ng-container
            *ngIf="!isInitialLoading(vm) && vm.isLoadingTransaction || isReloadingFromSortAction(vm)"
          >
            <ion-grid [fixed]="true" class="loading-content">
              <ion-skeleton-text
                *ngFor="let _ of [].constructor(5)"
                class="item"
                animated
              ></ion-skeleton-text>
            </ion-grid>
          </ng-container>
        </ion-grid>

        <ion-grid
          *ngIf="!isInitialLoading(vm) && !vm.isLoadingTransaction && vm.transactions.length <= 0 && vm.pageNum > 0"
          class="no-info-message"
        >
          <ion-row class="other-items-info">
            <ion-col class="other-items-title">
              <h5 data-cy="other-items">
                {{ 'i18n.payments.adjustPayment.otherItems' | translate }}
              </h5>
              <h5 data-cy="no-invoices-or-credits">
                {{ 'i18n.payments.adjustPayment.thereAreNoInvoices' | translate
                }}
              </h5>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ng-container>
      <ng-template #loadingContent>
        <ion-grid
          [fixed]="true"
          *ngIf="vm.isLoadingTransaction || isReloadingFromSortAction(vm)"
          class="loading-content"
        >
          <div
            *ngIf="isInitialLoading(vm) || isReloadingFromSortAction(vm)"
            class="title-content"
          >
            <ion-skeleton-text class="item" animated></ion-skeleton-text>
            <ion-skeleton-text class="item" animated></ion-skeleton-text>
          </div>
          <ion-skeleton-text
            *ngFor="let _ of [].constructor(5)"
            class="item"
            animated
          ></ion-skeleton-text>
        </ion-grid>
      </ng-template>
    </div>

    <app-footer></app-footer>
  </div>
</ion-content>

<div
  class="invoice-actions"
  *ngIf="vm$ | async; let vm"
  [class.pay-footer-hidden]="vm.selectedTransactions.length >= 1"
>
  <app-top-button
    *ngIf="!isInitialLoading(vm)"
    [mainScroll]="mainScroll"
    [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
  ></app-top-button>
</div>

<app-selection-banner
  *ngIf="vm$ | async; let vm"
  [class.ion-hide]="vm.selectedTransactions.length < 1 || isInitialLoading(vm)"
  [isMakePaymentFlow]="true"
  [isDownloadEnabled]="false"
  [showMainAction]="true"
  [countItemsSelected]="vm.selectedTransactions.length"
  [warningMessage]="warningMessageBanner"
  [labelMainActionBtn]="'i18n.payments.adjustPayment.reviewAndSubmit' | translate"
  slot="fixed"
  (deselectAllClickEmitter)="deselectAllSelections()"
  (mainActionClickEmitter)="paySelectedInvoices(vm.selectedTransactions)"
  (selectAllClickEmitter)="selectAllInvoices(vm)"
></app-selection-banner>

<ng-template
  #tableHeader
  let-currentSortField="currentSortField"
  let-currentSortDirection="currentSortDirection"
  let-isSelectedItems="isSelectedItems"
  let-vm="vm"
>
  <app-table-header
    *ngIf="platformService?.platformType === PlatformEnum.desktop"
    [dataColumns]="[
      {
        size:this.columnSizes[ColumnNames.Checkbox],
        dataCyName: 'checkbox',
        isCheckbox: true
      },
      {
        size:this.columnSizes[ColumnNames.CustomerInformation],
        dataCyName: 'customer',
        sortField: SortFields.customerName,
        sortDirectionByDefault: SortDirection.ASC,
        label: (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
          'i18n.payments.recentInvoicesCredits.customerCut' :
          'i18n.payments.recentInvoicesCredits.customer') | translate
      },
      {
        size:this.columnSizes[ColumnNames.TransactionInformation],
        dataCyName: 'transaction',
        sortField: SortFields.transaction,
        label: (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
          'i18n.payments.recentInvoicesCredits.transactionCut'
          : 'i18n.payments.recentInvoicesCredits.transaction') | translate
      },
      {
        size: this.columnSizes[ColumnNames.PoNumber],
        dataCyName: 'cust-po',
        sortField: SortFields.customerPO,
        label:  ('i18n.payments.recentInvoicesCredits.custPo' | translate)
      },
      {
              size: this.columnSizes[ColumnNames.OrderNumber],
              dataCyName: 'order-number',
              sortField: SortFields.orderNumber,
              label:  ('i18n.payments.recentInvoicesCredits.orderNumber' | translate)
            },
      {
        size: this.columnSizes[ColumnNames.IssueDate],
        dataCyName: 'issue-date',
        sortField: SortFields.issueDate,
        label:  (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
          'i18n.payments.recentInvoicesCredits.issueDateCut' :
          'i18n.payments.recentInvoicesCredits.issueDate') | translate
      },
      {
        size: this.columnSizes[ColumnNames.Amount],
        dataCyName: 'amount',
        sortField: SortFields.amount,
        label:  (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
          'i18n.payments.recentInvoicesCredits.amountCut'  :
          'i18n.payments.recentInvoicesCredits.amount') | translate
      },
      {
        size: this.columnSizes[ColumnNames.AmountDue],
        dataCyName: 'amount-due',
        sortField: SortFields.amountdue,
        label:  (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
          'i18n.payments.recentInvoicesCredits.amountDueCut'  :
          'i18n.payments.recentInvoicesCredits.amountDue') | translate
      },
      {
        size: this.columnSizes[ColumnNames.DueDate],
        dataCyName: 'due-date',
        sortField: SortFields.dueDate,
        label:  'i18n.payments.recentInvoicesCredits.dueDate' | translate
      },
      {
        size: this.columnSizes[ColumnNames.Status],
        dataCyName: 'status',
        sortField: SortFields.status,
        label:  (this.browserDimensions?.isPortrait && (isTouch$ | async) ?
          'i18n.payments.recentInvoicesCredits.statusCut'  :
        'i18n.payments.recentInvoicesCredits.status') | translate
      },
      {
        size: this.columnSizes[ColumnNames.EditAmount],
        dataCyName: 'payment-amount',
        label:  'i18n.payments.transactionRow.amount' | translate,
        isNotSortable: true
      },
      ]"
    [sortField]="currentSortField"
    [sortDirection]="currentSortDirection"
    [isSelectable]="vm.isSelectable"
    (clickEmit)="handleSort(vm, $event, isSelectedItems)"
  ></app-table-header>
</ng-template>
